import { render, staticRenderFns } from "./ZIQIUVYW.vue?vue&type=template&id=2a6bad8f&scoped=true&"
import script from "./ZIQIUVYW.vue?vue&type=script&lang=js&"
export * from "./ZIQIUVYW.vue?vue&type=script&lang=js&"
import style0 from "./ZIQIUVYW.vue?vue&type=style&index=0&id=2a6bad8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bad8f",
  null
  
)

export default component.exports